module.exports = __webpack_public_path__ + "media/images/flags/ZW-48ad83ab9999e27a0c653df613d4b0e1.svg";